import './pagination.scss';

import React, { useCallback } from 'react';

/**
 *    Pagination.tsx
 *
 *    onPageChange : Triggers this function when page changes
 *    currentPage  : current selected page
 *    pageNumber   : Number of pages to display
 *    showOnePage  : Display only the currentPage
 **/
export default function Pagination(props: {
    onPageChange: (newPage: number) => void;
    currentPage: number;
    pageNumber: number;
    showOnePage?: boolean;
}) {
    let pages: number[] = [];
    for (let x = 1; x < props.pageNumber + 1; x++) {
        pages.push(x);
    }

    const setPreviousPage = useCallback(() => {
        if (props.currentPage !== 1)
            return props.onPageChange(props.currentPage - 1);
    }, [props]);

    const setNextPage = useCallback(() => {
        if (props.currentPage !== props.pageNumber || props.showOnePage)
            return props.onPageChange(props.currentPage + 1);
    }, [props]);

    return (
        <div className='pagination'>
            <div className='arrow'>
                <span onClick={() => setPreviousPage()}>&lt;</span>
            </div>
            {props.showOnePage
                ? props.currentPage
                : pages.map((page, index) => (
                      <div
                          className={
                              props.currentPage === page
                                  ? 'pageNumber selected'
                                  : 'pageNumber'
                          }
                          onClick={() => props.onPageChange(page)}
                          key={index}
                      >
                          {page}
                      </div>
                  ))}
            <div className='arrow'>
                <span onClick={() => setNextPage()}>&gt;</span>
            </div>
        </div>
    );
}
